module.exports = __webpack_public_path__ + "img/edge_patrimoine_ferroviaire.c7a8b6bb.svg";